<!-- 報告不要業者一覧 > 報告不要業者追加 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <Form />
  </v-container>
</template>

<script>

  import Form from './_Form'
  // import BasicForm from './forms/_Basic'

  export default {
    name: 'DriverMasterNonReportingTraderNew',
    components: {
      Form,
    },
    mixins: [
    ],
    data () {
      return {
        product: null,
        breadcrumbs: [
          { text: '報告不要業者一覧', disabled: false, to: '/driver/masters/non_reporting_traders', exact: true },
          { text: '報告不要業者追加', disabled: true, to: '' },
        ],
        non_reporting_trader: null
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="scss">

</style>
